import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { GlobalErrorHandlerService } from './global-error-handler.service';

import { Healthgroup } from '../healthgroup/healthgroup';
import { Clinic } from '../clinic/clinic';

const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'})
};

@Injectable({
  providedIn: 'root'
})
export class HealthgroupService {

  private healthgroupsUrl = '/api/health_groups';

  constructor(
    private http: HttpClient,
    private errorHandler: GlobalErrorHandlerService
  ) { }

  getHealthgroup(id: number): Observable<Healthgroup> {
    return this.http
      .get<Healthgroup>(`${this.healthgroupsUrl}/${id}`)
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }

  getCurrentLoggedInUser(id: number): Observable<any> {
    return this.http
      .get<any>(`${this.healthgroupsUrl}/user/${id}`)
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }

  getClinic(id: number, clinicId: number): Observable<Clinic> {
    if (!id || !clinicId) { return of(); }
    return this.http
      .get<Clinic>(`${this.healthgroupsUrl}/${id}/clinic/${clinicId}`)
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }

  getDoctors(id: number): Observable<any> {
    if (!id) { return of(); }
    return this.http
      .get(`${this.healthgroupsUrl}/${id}/doctors`)
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }

  findClinicByUserName(userName: string): Observable<any> {
    if (!userName.trim()) { return of(); }
    return this.http
      .get(`${this.healthgroupsUrl}/?username=${userName}`)
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }
}
